import { Accordion, AccordionItem, Col, Collapse, Row } from 'reactstrap';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import { getTravelInfo } from '../../../slice';
import { Tile } from '../../../../../../Components/Custom/Tile';
import { TravelHub } from '../TravelHub';

export const Travel = () => {
  const { loading, travel } = useAppSelector((state) => state.userDetails);

  const [col, setCol] = useState(true);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getTravelInfo(Number(userId)));
  }, [dispatch]);

  return (
    <div>
      <div className='accordion-body'>
        {travel?.map((data, i) => (
          <TravelHub key={i} data={data} />
        ))}
      </div>
      {/* <Accordion open={'3'}>
        <AccordionItem>
          <h2 className='accordion-header' id='headingTwo'>
            <button
              className={classnames('accordion-button', { collapsed: !col })}
              type='button'
              onClick={t_col}
              style={{ cursor: 'pointer' }}>
              My Travelution Memberships
            </button>
          </h2>
          <Collapse isOpen={col} className='accordion-collapse'>
            
          </Collapse>
        </AccordionItem>
      </Accordion> */}
    </div>
  );
};
